import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ApiKey';
const ENDPOINT = `/api-keys/`;

@Injectable({
    providedIn: 'root'
})
export class ApiKeyService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
